import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { TwoStepWrap, TwoStepContainer } from './styles/TwoStepStyle';
import TwoStepChoice from './TwoStepChoice';
import TwoStepCode from './TwoStepCode';
import TwoStepSuccess from './TwoStepSuccess';
import TwoStepRecover from './TwoStepRecover';
import TwoStepConfirm from './TwoStepConfirm';
import { WelcomeContext } from '../../context/index';
import { UserContext } from '../../context/UserProvider';
import { checkOnboardingState } from '../../utils/commonFunctions';

const TwoStep = () => {
  const [stepState, setStepState] = useState('CHOICE');
  const { welcome } = useContext(WelcomeContext) || {};
  const { update } = useContext(UserContext);
  const history = useHistory();

  useEffect(() => {
    checkOnboardingState(welcome, update, history);
  }, [welcome]);

  useEffect(() => {
    if (sessionStorage.getItem('rememberMe')) {
      const currentTime = new Date().toLocaleTimeString();
      localStorage.setItem('rememberMe', currentTime);
    }
  }, []);

  const renderTwoStepStage = () => {
    if (stepState === 'CHOICE') return <TwoStepChoice setState={setStepState} />;
    if (stepState === 'CODE') return <TwoStepCode setState={setStepState} />;
    if (stepState === 'SUCCESS') return <TwoStepSuccess />;
    if (stepState === 'CONFIRM') return <TwoStepConfirm setState={setStepState} />;
  };

  return (
    <TwoStepWrap>
      <TwoStepContainer className={stepState === 'SUCCESS' ? 'success' : ''}>{renderTwoStepStage()}</TwoStepContainer>
      {stepState === 'SUCCESS' && (
        <TwoStepContainer className="recover">
          <TwoStepRecover setState={setStepState} />
        </TwoStepContainer>
      )}
    </TwoStepWrap>
  );
};

export default TwoStep;
